import { MondayLogo } from "frontend/icons/monday-logo";
import { ReactNode } from "react";

type IconName = "monday";

const iconMapper: Record<IconName, (width?: number, height?: number) => ReactNode> = {
  monday: (width?: number, height?: number) => <MondayLogo width={width} height={height} />,
};

export const getContentCardIcon = (name: string | undefined) => {
  if (!name) {
    return null;
  }
  return iconMapper[name as IconName] ?? null;
};
